import { Vector3 } from "three";
import { Annotation } from "@/components/annotation";
import { useViewSettings } from "@/view-settings";
import { useSelector } from "@legendapp/state/react";

export function CameraLabel({
  cameraId,
  isActive,
  isHovered,
  position,
}: {
  cameraId: string;
  isActive?: boolean;
  isHovered?: boolean;
  position: Vector3;
}) {
  const viewSettings = useViewSettings();
  const isLabelEnabled = useSelector(() => viewSettings.showCameraLabel.get());

  if (!isLabelEnabled) return null;

  return (
    <Annotation
      distanceFactor={2}
      position={position}
      zIndexRange={[100, 0]}
      transform
      wrapperClass="camera-frustum-label"
    >
      <span
        className={`pointer-events-none text-shadow text-base font-bold ${
          isActive ? "text-orange-600" : ""
        } ${isHovered ? "text-orange-800" : ""}`}
      >
        {cameraId}
      </span>
    </Annotation>
  );
}
